import { sortNumber } from './sortNumber';
import { sortString } from './sortString';
import { ItemSort } from './types';

type SortItemsByPropertyParams<TItem> = ItemSort<TItem> & {
  items: TItem[];
};

/**
 *
 * This is used for sorting an array of items but a single property
 *
 * @param options
 * @param options.items The Items to sort.
 * @param options.property the property to sort on, must be a property of the passed items
 * @param options.sortDirection Either Ascending or Descending
 */
export function sortItemsByProperty<TItem>({
  items,
  property,
  sortDirection,
}: SortItemsByPropertyParams<TItem>) {
  if (!property) return items;
  if (!items) return items;
  if (items.length <= 1) {
    return items;
  }
  const sorted = [...items].sort((a, b) => {
    let propA: any = a[property];
    let propB: any = b[property];

    if (typeof propA !== typeof propB) {
      console.log(
        'Properties are not the same type. Converting both types to string.'
      );
      propA = `${propA}`;
      propB = `${propB}`;
    }

    if (typeof propA === 'string' && typeof propB === 'string') {
      return sortString({ a: propA, b: propB, sortDirection });
    } else if (typeof propA === 'number' && typeof propB === 'number') {
      return sortNumber({ a: propA, b: propB, sortDirection });
    } else if (propA instanceof Date && propB instanceof Date) {
      return sortNumber({
        a: propA.getTime(),
        b: propB.getTime(),
        sortDirection,
      });
    } else {
      console.log('Unimplemented sort type. Falling back to string sort.');
      return sortString({ a: `${propA}`, b: `${propB}`, sortDirection });
    }
  });
  return sorted;
}
